<template>
  <div>
    <div v-if="TypeStyle">
      <div class="hoverOpenzimu" v-if="runbarrageList.length !=0">
          <div  @click="barrageListClick(item)" v-for="(item,index) in runbarrageList" :key="index"  :class="runbarrageListState?'':'sendOK'" class="hoverOpenzimuItem"> {{item.content}}</div>
      </div>
      <div class="hoverOpenzimu" v-else>
          <div style="text-align: center;width: 100%;min-height: 40px;line-height: 40px;">暂无内容</div>
      </div>
    </div>
    <div v-else>
      <!-- 发言提示 -->
      <div class="pushMessageScroll" id="pushMessageScroll" v-if="runbarrageList && runbarrageList.length > 0">
          <div class='addLeft'  @click="changeleft(1)" >
              <img src="/static/room/addRight.png" alt="" v-show="changeleftState">
          </div>
        <!--  <div class='closemessage' :class="!changeleftState?'indexShow':''" @click="closedanmu" >
            <img  v-if="!changeleftState" src="/static/room/closemessage.png" alt="" srcset="">
          </div> -->
          <div class="scrollMessageList">
            <div class="scrollwidth" :style="{'left':leftIndex + 'px'}">
                <div class="showMessageItem" @click="barrageListClick(item)" :class="runbarrageListState?'':'sendOK'"  v-for="(item,index) in runbarrageList" :key="index">
                  {{item.content}}
                </div>
            </div>
          </div>
           <div class='addRight' @click="changeleft(2)" >
              <img src="/static/room/addRight.png" alt="" v-show="changerightState">
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import{ barrageword } from "@/api/lz.js";
  export default {
    props:{
      TypeStyle:{
        type:Boolean,
        default:true
      }
    },
    data() {
      return {
        key: 'value',
        leftIndex:0,
        changerightState:true,
        changeleftState:false,
        runbarrageList:[], // 快捷弹幕
        runbarrageListState:true,
      }
    },
    created() {
      // 快捷弹幕
      barrageword({}).then(res=>{
        if(res.data.code ==200){
          // console.log('快捷弹幕',res.data.data);
          this.runbarrageList = res.data.data;

          // setTimeout(()=>{

          //   // 可视区域长度
          //   let { width } =  document.querySelectorAll('.pushMessageScroll')[0].getBoundingClientRect();
          //   // 获取总长度
          //   let allWidth =  document.querySelectorAll('.scrollwidth')[0].getBoundingClientRect();

          //   console.log();

          //   if(allWidth.width < width){
          //     this.changerightState = false;
          //   }else{
          //     this.changerightState = true;
          //   }
          // },500)


        }
      })
    },
    methods:{
      // 关闭快捷弹幕
      closedanmu(){
        console.log('关闭1');
        this.$emit('closeMessage')
      },
      // 发送快捷消息
      barrageListClick(item){
        if(this.runbarrageListState){
            // this.messageInput = item.content;
            // this.send();
            this.$emit('sendMessage', item.content)
            this.runbarrageListState = false;
            setTimeout(()=>{
            this.runbarrageListState = true;
            },1000 * 5)
        }
      },
      // 切换快捷消息提示
      changeleft(val){
        // 可视区域长度
        let { width } =  document.querySelectorAll('.pushMessageScroll')[0].getBoundingClientRect();
        // 获取总长度
        let allWidth =  document.querySelectorAll('.scrollwidth')[0].getBoundingClientRect();
        let deep =  Math.floor(allWidth.width)  / Math.floor(width)


        if(val ==1){
          // 左移动
          if(this.leftIndex <=0){
            this.leftIndex += Math.floor(width) / 2 + 5 // 每次移动可视区域的一半
            if( this.leftIndex >0){
               this.leftIndex  = 0;
               this.changeleftState = false;
            }
            this.changerightState = true;
          }else{
            this.changeleftState = true;
            this.changerightState = true;

          }
        }else{
          // 右移动
          if(allWidth.width > (Math.abs(this.leftIndex) + Math.floor(width)) ){
            this.leftIndex -= Math.floor(width) / 2  // 每次移动可视区域的一半
            if(allWidth.width < (Math.abs(this.leftIndex) + Math.floor(width))){
              this.changerightState = false;
            }
            this.changeleftState = true;
          }

        }
        // console.log(val, Math.floor(allWidth.width) ,Math.floor(width),deep ,this.leftIndex, (Math.abs(this.leftIndex) + Math.floor(allWidth.width)) )
      },
    }
  }
</script>
<style lang="scss" scoped>
  .pushMessageScroll:hover{
    .addLeft{
      display: block !important;
      z-index: 10;
      img{
        padding-right: 4px;
        background-color: #fff;
      }
    }
    .addRight{
      display: block !important;
      background-color: #fff;
      padding-left: 4px;
    }
    .closemessage{
      // border: 1px solid red;
      z-index: 18;
      position: relative;
      img{
        display: block !important;
      }
    }
  }
  .pushMessageScroll{
      height: 35px;
      overflow: hidden;
      padding: 0 12px;
      margin-bottom: 12px;
      position: relative;
      display: flex;
      align-items: center;

      .addLeft{
        display: none;
        position:absolute;
        left:0px;
        width: 18px;
        transform: rotate(180deg);
        height:24px;
        z-index: 19;
        img{
          width: 18px;
          height:24px;
        }
      }

      .addRight{
        display: none;
        position:absolute;
        right:0px;
        width: 18px;
        height:24px;
        z-index: 19;
        img{
          width: 18px;
          height:24px;
        }
      }
      .indexShow{
        z-index:30 !important;
      }
      .closemessage{
        width: 24px;
        height: 24px;
        margin-right: 24px;
        img{
          display: block;
          width: 24px;
          height: 24px;
        }
      }
  }
  .sendOK{
    color: #999999 !important;
  }
  .scrollMessageList{
    // border: 1px solid red;
    overflow-x: scroll;
    max-width: 390px;
    width: 100%;
    .scrollwidth{
    position: relative;
    left: 0;
    transition: all .2s;
    display:inline-flex;
    }

    .showMessageItem{
      cursor: pointer;
      margin-bottom: 26px;
      transform: translateY(17px);
      height: 22px;
      padding: 1px 10px;
      background: #FFFFFF;
      margin-right:8px;
      white-space: nowrap;
      border-radius: 4px;
      border: 1px solid #DADADA;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #333333;
      display: inline;
      box-sizing: border-box;
      transition:all .2s;
    }
    .showMessageItem:hover{
      color: #fff;
      background-color: #721EDC;
      transition:all .1s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_roombarrage.vue